/**
 * Full-page image gallery overlay; locks body scrolling while it is open.
 */
export default function imageGalleryModal() {
    return {
        isGalleryModalOpen: false,

        openGalleryModal() {
            this.isGalleryModalOpen = true;
            document.body.style.overflow = 'hidden';
        },

        closeGalleryModal() {
            this.isGalleryModalOpen = false;
            document.body.style.overflow = '';
        },
    };
}
